import styled from 'styled-components';
import theme from 'theme/theme';

const Title3 = styled.h3`
  display: flex;
  padding: 0;
  margin: 0;
  font-size: ${theme.fontSizes.large};
`;

export default Title3;
